import type { LucideIcon } from 'lucide-react';
import {
  AlertTriangle, AppWindow, ArrowRightLeft, Bell, Calendar, CircleDollarSign, ClipboardList, Gamepad2, Gift, Globe, Hexagon,
  Home, MessageSquare, Percent, Settings, ShieldAlert, ShieldCheck, Smartphone, UserCircle, Users, Wallet,
} from 'lucide-react';
import { GROUP, PAGE } from '@kioskgaming/ui';

export type NavItem = {
  to: string;
  label: string;
  icon: LucideIcon;
  end?: boolean;
  /** Extra prefixes that keep this item active. */
  match?: string[];
  /** Count shown next to the label (hidden when 0). */
  badge?: number;
};

export const CASHIER_DEVICES_PATH = '/cashier-devices';

export const APPROVALS_NAV_ITEMS: NavItem[] = [
  { to: '/withdrawals', icon: ShieldCheck, label: PAGE.withdrawalRequests },
  { to: '/redemption-approvals', icon: CircleDollarSign, label: PAGE.redemptionApprovals },
];

export const NETWORK_NAV_ITEMS: NavItem[] = [
  { to: '/players', icon: Users, label: PAGE.players, match: ['/transfer'] },
  { to: '/game-wallets', icon: Gamepad2, label: PAGE.gameWallets },
  { to: '/fraud-indicators', icon: ShieldAlert, label: PAGE.fraudIndicators },
];

export const CASHIER_NAV_ITEMS: NavItem[] = [
  { to: '/cashiers', icon: UserCircle, label: PAGE.cashiers },
  { to: '/shifts', icon: Calendar, label: PAGE.shifts, match: ['/reconciliation'] },
  { to: CASHIER_DEVICES_PATH, icon: Smartphone, label: PAGE.devices },
  { to: '/cashier-exceptions', icon: AlertTriangle, label: PAGE.shiftExceptions },
  { to: '/shift-reports', icon: ClipboardList, label: PAGE.shiftReports },
];

export const TRANSACTIONS_NAV_ITEMS: NavItem[] = [
  { to: '/transactions', icon: ArrowRightLeft, label: PAGE.creditTransactions, match: ['/money'] },
  { to: '/cash-settlement/deposits', icon: Hexagon, label: PAGE.cashTransactions, match: ['/cash-settlement'] },
  { to: '/online-transactions', icon: Wallet, label: PAGE.usdWalletTransactions },
];

export const MESSAGES_NAV_ITEMS: NavItem[] = [
  { to: '/popups/send', icon: AppWindow, label: PAGE.popups },
  { to: '/broadcasts/send', icon: Bell, label: PAGE.broadcasts },
  { to: '/messages/compose', icon: MessageSquare, label: PAGE.emailSms, match: ['/messages'] },
];

export const DEPOSIT_BONUS_LABEL = 'Deposit bonus campaign';

export const SETTINGS_NAV_ITEMS: NavItem[] = [
  { to: '/settings', end: true, icon: Settings, label: PAGE.settings },
  { to: '/deposit-bonus', icon: Gift, label: DEPOSIT_BONUS_LABEL },
  { to: '/provider-fees', icon: Percent, label: PAGE.feeConfiguration },
  { to: '/kiosk-domain', icon: Globe, label: PAGE.kioskUrl },
];

export const POPUP_NAV_PATHS = new Set(['/popups/send', '/broadcasts/send']);

export const MOBILE_NAV: NavItem[] = [
  { to: '/', end: true, icon: Home, label: PAGE.dashboard },
  { to: '/players', icon: Users, label: PAGE.players, match: ['/game-wallets', '/fraud-indicators', '/transfer'] },
  { to: '/transactions', icon: ArrowRightLeft, label: GROUP.transactions, match: ['/money', '/cash-settlement', '/online-transactions'] },
  { to: '/cashiers', icon: UserCircle, label: PAGE.cashiers, match: CASHIER_NAV_ITEMS.map((i) => i.to).concat(['/reconciliation']) },
  { to: '/popups/send', icon: MessageSquare, label: GROUP.messages, match: ['/messages', '/popups', '/broadcasts'] },
  { to: '/settings', icon: Settings, label: PAGE.settings, match: ['/deposit-bonus', '/provider-fees', '/kiosk-domain'] },
];
